import { CALL_UNIQUE_EXTERNAL_ID_PROPERTY, LEGACY_CALL_OBJECT_UUID_PROPERTY } from '../constants/callObject';
export const resolveCallObjectUniqueProperty = callProperties => {
  return callProperties[CALL_UNIQUE_EXTERNAL_ID_PROPERTY] || callProperties[LEGACY_CALL_OBJECT_UUID_PROPERTY] || '';
};